
import React, { ReactNode, createContext, Dispatch, useReducer, useContext } from 'react'
 
 //Interfaces
interface Props {
  children?: ReactNode
  // any props that come into the component
}
//export Interfaces

export interface FetchTracker{
    skid:boolean,
    views:boolean,
    viewConfig:boolean,
    skidsWithConfig:boolean,
    skidHeaders?:boolean
}

export interface FetchTrackerAction{
    type:'skid' | 'views' | 'viewConfig' | 'skidsWithConfig' | 'skidHeaders',
    value:boolean
}

export const FetchTrackerContext = createContext<FetchTracker |null >(null);
const fetchTrackerDispatchContext = createContext<Dispatch<FetchTrackerAction> | null>(null);

export function useTracker(){
    return useContext(FetchTrackerContext)
}
export function useTrackerDispatch(){
    return useContext(fetchTrackerDispatchContext)
}
export default function FetchTrackerProvider({children}:Props){
    const [fethcTracker, dispatch] = useReducer(fetchTrackerReducer, initialFetchTracker);
    return (
        <FetchTrackerContext.Provider value={fethcTracker}>
            <fetchTrackerDispatchContext.Provider value={dispatch}>
                {children}
            </fetchTrackerDispatchContext.Provider>
        </FetchTrackerContext.Provider>
    );
}
function fetchTrackerReducer(fetchTracker:FetchTracker, action:FetchTrackerAction){
    switch(action.type){
        case 'skid':{
            return {...fetchTracker, skid:action.value}
        }
        case 'views':{
            return {...fetchTracker, views:action.value}
        }
        case 'viewConfig':{
            return {...fetchTracker, viewConfig:action.value}
        }
        case 'skidsWithConfig':{
            return {...fetchTracker, skidsWithConfig:action.value}
        }
        case 'skidHeaders':{
            return {...fetchTracker, skidHeaders:action.value}
        }
        default: {
            throw new Error('Invalid action type: '+ action.type)
        }
    }
}

const initialFetchTracker:FetchTracker = {skid:false, views:false, viewConfig:false, skidsWithConfig:false}